"use client";
import { offersData } from "@/data/offers";
import { useParams } from "next/navigation";
import { notFound } from "next/navigation";
import { IntroSection } from "../sections/IntroSection";
import { PriceSection } from "../sections/PriceSection";
import { ServicesSection } from "../sections/ServicesSection";
import { EquipmentsSection } from "@/components/sections/EquipmentsSection";
import { BannerSection } from "@/components/sections/BannerSection";
import { BreadcrumbOffersPage } from "../sections/BreadcrumbOffersPage";
import { ContactSection } from "@/(landing-page)/sections/ContactSection";
import { Suspense } from "react";

export default function Offer() {
  const { slug } = useParams();

  // Recherche de l'offre correspondante dans les 4 types d'offres
  const offer =
    slug === offersData.sharedOpenSpace.id
      ? offersData.sharedOpenSpace
      : slug === offersData.privateOpenSpace.id
        ? offersData.privateOpenSpace
        : slug === offersData.privateOffices.id
          ? offersData.privateOffices
          : slug === offersData.entireFloor.id
            ? offersData.entireFloor
            : null;

  if (!offer) {
    return notFound();
  }

  return (
    <main className="flex max-w-[100vw] flex-col">
      <BannerSection title="Nos offres" />
      <BreadcrumbOffersPage />
      <IntroSection offer={offer} />
      <PriceSection offer={offer} />
      <Suspense fallback={null}>
        <ContactSection />
      </Suspense>
      <ServicesSection />
      <EquipmentsSection />
    </main>
  );
}
